module.exports = __webpack_public_path__ + "media/images/core_values/family-91e5a1ab3f1f66fceb5ee248279d2ee4.png";